<clr-modal [(clrModalOpen)]="modalAccountOpen" [clrModalSize]="'xl'">
	<h3 class="modal-title">About</h3>
	<div class="modal-body">
		
		<table class="table table-vertical">
			<tbody>
				@if (globalVersion()) {
				<tr>
					<td class="left">Version</td>
					<td>{{ globalVersion()}}</td>
				</tr>
			    }
			    @if (serviceRegion()) {
				<tr>
					<td class="left">Region</td>
					<td>{{ serviceRegion() }}</td>
				</tr>
				}
				<tr>
					<td class="left">Open Source Licenses<br />Frontend</td>
					<td>
						<iframe id="iframeOssFrontend"
							title="Open Source Licenses - Frontend"
							width="100%"
							height="500px"
							[frameBorder]="0"
							src="/assets/oss-licenses/frontend.txt">
						</iframe>
					</td>
				</tr>
				<tr>
					<td class="left">Open Source Licenses<br />WASM</td>
					<td>
						<iframe id="iframeOssWasm"
							title="Open Source Licenses - WASM"
							width="100%"
							height="500px"
							[frameBorder]="0"
							src="/assets/oss-licenses/wasm.txt">
						</iframe>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
	<div class="modal-footer">
		<button type="button" class="btn btn-outline" (click)="modalAccountOpen = false">Close</button>
	</div>
</clr-modal>
